"use strict";
exports.__esModule = true;
exports.chart_color_black_400 = {
  "name": "--pf-v5-chart-color-black-400",
  "value": "#8a8d90",
  "var": "var(--pf-v5-chart-color-black-400, #8a8d90)"
};
exports["default"] = exports.chart_color_black_400;